export { AccessTypePlanModalWrapper as WhitelabelPlanModalWrapper } from "features/MySubscriptions/modules/AccessTypePlanModalWrapper/AccessTypePlanModalWrapper";
